/* MkaeSense city safety hub: search, rankings, globe controls. rows: [handle,name,region,cc,lat,lon,pop,br,mv,th,vi,idx] */
(function () {
  var root = document.getElementById('hb'); if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var load = window.mkG3data ? window.mkG3data(root.dataset.src) : fetch(root.dataset.src).then(function (r) { return r.json(); });
  var NAMES = { AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba', NB: 'New Brunswick', NL: 'Newfoundland and Labrador', NS: 'Nova Scotia', ON: 'Ontario', PE: 'Prince Edward Island', QC: 'Quebec', SK: 'Saskatchewan' };
  function norm(s) { return s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’'.]/g, '').toLowerCase(); }
  function fmt(n) { return n == null ? '–' : n >= 10 ? n.toFixed(1) : n.toFixed(2).replace(/0$/, ''); }
  function el(t, c, txt) { var e = document.createElement(t); if (c) e.className = c; if (txt != null) e.textContent = txt; return e; }
  function url(r) { return '/pages/city/' + r[0]; }
  function tone(i) { return i >= 67 ? 'g' : i >= 34 ? 'm' : 'b'; }

  load.then(function (rows) {
    rows.forEach(function (r) { r.q = norm(r[1] + ' ' + r[2]); });
    [7, 8, 9, 10].forEach(function (m) {
      ['US', 'CA'].forEach(function (cc) {
        var s = rows.filter(function (r) { return r[3] === cc && r[m] != null; }).sort(function (a, b) { return a[m] - b[m]; });
        s.forEach(function (r, i) { (r.pc = r.pc || {})[m] = i / Math.max(1, s.length - 1); });
      });
    });
    stats(rows); search(rows); table(rows);
  }).catch(function () { $('#hb-tb').innerHTML = '<tr><td colspan="8" class="hb-load">The city data didn’t load. Refresh the page to try again.</td></tr>'; });

  function stats(rows) {
    function top(cc, min, key) {
      var s = rows.filter(function (r) { return r[3] === cc && r[6] >= min && r[key] != null; }).sort(function (a, b) { return b[key] - a[key]; });
      return s[0];
    }
    var set = function (k, r, val) { var b = root.querySelector('[data-k="' + k + '"]'); if (!b || !r) return; b.innerHTML = ''; var a = el('a', '', r[1] + ', ' + r[2]); a.href = url(r); b.appendChild(a); b.appendChild(el('em', '', val)); };
    var a = top('US', 100000, 11); set('safest', a, a && a[11] + ' / 100');
    var b = top('US', 100000, 7); set('br', b, b && fmt(b[7]) + ' per 1,000');
    var c = top('CA', 100000, 8); set('mv', c, c && fmt(c[8]) + ' per 1,000');
    var d = top('CA', 100000, 11); set('casafe', d, d && d[11] + ' / 100');
  }

  function search(rows) {
    var q = $('#hb-q'), list = $('#hb-res'), hits = [], act = -1;
    function close() { list.hidden = true; q.setAttribute('aria-expanded', 'false'); act = -1; }
    function draw() {
      list.innerHTML = '';
      if (!hits.length) { list.appendChild(el('li', 'hb-none', 'No city of 25,000+ matches that name.')); }
      hits.forEach(function (r, i) {
        var li = el('li'), a = el('a'); li.setAttribute('role', 'option'); li.id = 'hb-o' + i; if (i === act) li.setAttribute('aria-selected', 'true');
        a.href = url(r);
        var n = el('span', 'hb-rn'); n.appendChild(el('b', '', r[1])); n.appendChild(el('small', '', (NAMES[r[2]] || r[2]) + ' · ' + Math.round(r[6]).toLocaleString() + ' people'));
        var ix = el('span', 'hb-pill hb-' + tone(r[11]), r[11]);
        ix.setAttribute('aria-label', 'Safety Index ' + r[11]);
        a.appendChild(n); a.appendChild(ix); li.appendChild(a); list.appendChild(li);
      });
      list.hidden = false; q.setAttribute('aria-expanded', 'true');
      if (act >= 0) q.setAttribute('aria-activedescendant', 'hb-o' + act); else q.removeAttribute('aria-activedescendant');
    }
    q.addEventListener('input', function () {
      var v = norm(q.value.trim()); if (v.length < 2) { close(); return; }
      var starts = [], inc = [];
      rows.forEach(function (r) { var n = norm(r[1]); if (n.indexOf(v) === 0) starts.push(r); else if (r.q.indexOf(v) >= 0) inc.push(r); });
      var by = function (a, b) { return b[6] - a[6]; };
      hits = starts.sort(by).concat(inc.sort(by)).slice(0, 7); act = hits.length ? 0 : -1; draw();
    });
    q.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      if (e.key === 'ArrowDown') { act = Math.min(hits.length - 1, act + 1); draw(); e.preventDefault(); }
      else if (e.key === 'ArrowUp') { act = Math.max(0, act - 1); draw(); e.preventDefault(); }
      else if (e.key === 'Enter' && hits[act]) { location.href = url(hits[act]); e.preventDefault(); }
      else if (e.key === 'Escape') close();
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.hb-search')) close(); });
  }

  function table(rows) {
    var cc = /#ca\b/i.test(location.hash) ? 'CA' : 'US', shown = 50;
    var sort = $('#hb-sort'), pop = $('#hb-pop'), reg = $('#hb-reg'), tb = $('#hb-tb'), more = $('#hb-more');
    var tabs = root.querySelectorAll('.hb-cc button');
    function regions() {
      var have = {}; rows.forEach(function (r) { if (r[3] === cc) have[r[2]] = 1; });
      var codes = Object.keys(have).sort(function (a, b) { return (NAMES[a] || a).localeCompare(NAMES[b] || b); });
      reg.innerHTML = '<option value="">All</option>';
      codes.forEach(function (c) { var o = el('option', '', NAMES[c] || c); o.value = c; reg.appendChild(o); });
      $('#hb-rl').textContent = cc === 'CA' ? 'Province' : 'State';
    }
    function list() {
      var s = sort.value, min = +pop.value, rg = reg.value;
      var out = rows.filter(function (r) { return r[3] === cc && r[6] >= min && (!rg || r[2] === rg); });
      var k = s === 'idx-d' || s === 'idx-a' ? 11 : +s, asc = s === 'idx-a';
      out.sort(function (a, b) { var x = a[k], y = b[k]; if (x == null) return 1; if (y == null) return -1; return asc ? x - y : y - x; });
      return out;
    }
    function cell(r, m) {
      var td = el('td', 'hb-r');
      if (r[m] == null) { td.textContent = '–'; td.title = 'Not reported'; return td; }
      var i = el('i'); i.style.setProperty('--p', r.pc[m]); td.appendChild(i); td.appendChild(document.createTextNode(fmt(r[m]))); return td;
    }
    function draw() {
      var all = list(), part = all.slice(0, shown), f = document.createDocumentFragment();
      part.forEach(function (r, i) {
        var tr = el('tr');
        tr.appendChild(el('td', 'hb-n', i + 1));
        var th = el('th'); th.scope = 'row'; var a = el('a', '', r[1]); a.href = url(r); th.appendChild(a); th.appendChild(el('small', '', r[2])); tr.appendChild(th);
        var ix = el('td', 'hb-ix'), bar = el('span', 'hb-ib hb-' + tone(r[11])); bar.style.setProperty('--v', r[11] / 100);
        ix.appendChild(el('b', '', r[11])); ix.appendChild(bar); tr.appendChild(ix);
        [7, 8, 9, 10].forEach(function (m) { tr.appendChild(cell(r, m)); });
        tr.appendChild(el('td', 'hb-pp', Math.round(r[6]).toLocaleString()));
        tr.addEventListener('click', function (e) { if (!e.target.closest('a')) location.href = url(r); });
        f.appendChild(tr);
      });
      tb.innerHTML = ''; if (!part.length) { tb.innerHTML = '<tr><td colspan="8" class="hb-load">No cities match these filters.</td></tr>'; } tb.appendChild(f);
      more.hidden = all.length <= shown; more.textContent = 'Show ' + Math.min(50, all.length - shown) + ' more of ' + all.length.toLocaleString();
    }
    function setCC(c, push) {
      cc = c; shown = 50; reg.value = '';
      tabs.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.cc === cc ? 'true' : 'false'); });
      regions(); draw(); if (push) history.replaceState(null, '', '#' + cc.toLowerCase());
    }
    tabs.forEach(function (b) { b.addEventListener('click', function () { setCC(b.dataset.cc, true); }); });
    [sort, pop, reg].forEach(function (x) { x.addEventListener('change', function () { shown = 50; draw(); }); });
    more.addEventListener('click', function () { shown += 50; draw(); });
    window.addEventListener('hashchange', function () { if (/#(us|ca)\b/i.test(location.hash)) setCC(/#ca/i.test(location.hash) ? 'CA' : 'US'); });
    setCC(cc);
    if (/#(us|ca)\b/i.test(location.hash)) $('#rankings').scrollIntoView();
  }

  var seg = root.querySelectorAll('.hb-ctl .cx-seg button'), gEl = root.querySelector('[data-g3]');
  seg.forEach(function (b) {
    b.addEventListener('click', function () {
      seg.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      gEl.dataset.metric = b.dataset.m; if (gEl.__g3) gEl.__g3.setMetric(+b.dataset.m);
    });
  });
})();
